import React, { useState, useEffect, useRef } from "react";
import {useHistory} from "react-router-dom";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import fullTextService from "../../../services/fulltextsearch";
import _ from "lodash";
import { toast } from "react-toastify";
import CheckBox from '../../../shared/Fields/CheckBox';
import SynonymEditor from "./SynonymEditor";
import { get as getFromStorage, set as setInStorage, STORAGE_DOMAINS } from '../../../services/storage/GQStorage';


function EditSearchTerms(){

    const leftRef = useRef(null);    

    const [dragging, setDragging] = useState(false);
    const [leftWidth, setLeftWidth] = useState(null)

    const [searchForTerm, setSearchForTerm] = useState("");
    const [searchedTerm, setSearchedTerm] = useState("");

    const [searchTerms, setSearchTerms] = useState([]);

    const [activeIndex, setActiveIndex] = useState(-1);   
    const [activeTerm, setActiveTerm] = useState(null); 

    const { t, i18n } = useTranslation("common");
    const history = useHistory();

    const userInfo = useSelector((state) => state.setUserInfo);    
    const toggle = useSelector(state => state.setToggle.toggle);

    const [ontologyState, setOntologyState] = useState(null);    

    function getOntologyString(){

		let ontologyString = "";
		let keys = Object.keys(ontologyState);

		for(var i =0; i<keys.length; i++){
			if(ontologyState[keys[i]][1]){
				ontologyString+=';'+keys[i];
			}
		}

		return ontologyString;
	}
    
    useEffect(async() => {
        let initial = {
            CHEBI:    ['Chemical Entities of Biological Interest (CHEBI)', false],
            DOID:     ['Human Disease Ontology (DOID)', false],
            GO:       ['Gene Ontology (GO)', false],
            HP:       ['Human Phenotype Ontology (HP)', false],
            IMR:      ['INOH Protein name/family name ontology (IMR)', false],
            MOD: 	  ['Protein Modification (MOD)', false],
            MSH: 	  ['Medical Subject Headings (MSH)', true],
            NCBI: 	  ['NCBI organismal classification (NCBI)', true],
            PO: 	  ['Plant Ontology (PO)', false],
            PR: 	  ['Protein Ontology (PR)', false],
            // Remove below item for now due to the license restriction
            // SNOMEDCT: ['Systematized Nomenclature of Medicine - Clinical Terms (SNOMEDCT)', false],
            TO: 	  ['Plant Trait Ontology (TO)', false],
            USER: 	  ['Your word lists (USER)', true],
        }

        let state = getFromStorage("FTOntologies", null, { parse: false });
        if(state !== undefined && state !== null){
            let stateObj = JSON.parse(state);
            initial = {...stateObj}
            //saveOntologyState({...stateObj})
        }else{
            setInStorage("FTOntologies", initial, STORAGE_DOMAINS.CACHE)
        }

        delete initial.USER;
        setOntologyState(initial);
    },[]);

    const changeOntology = (key) => { //handles change on checkboxes
		var thisOnt = ontologyState;
		var oldOntVal = thisOnt[key] //swaping in the new value
		oldOntVal = [oldOntVal[0], !oldOntVal[1]];
		thisOnt[key] = oldOntVal;

		setOntologyState({...thisOnt});
	}

    function resizeTable(e){
        if(e.clientX > 0){
            let newWidth = e.clientX - leftRef.current.offsetLeft
            if(newWidth < 274){
                newWidth = 274;
            }
            if(newWidth > 500){
                newWidth = 500;
            }
            console.log(newWidth)
            setLeftWidth(newWidth)
        }
    }

    function widthFunction(){
        if(leftWidth == null){
            return "274px"
        }else{
            return leftWidth+"px"
        }
    }


    useEffect(async() => {

        getOntoSuggestions()

    },[searchForTerm])


    const selectOntology = (index) =>{

        if(index == activeIndex){
            searchTerms[activeIndex].editedSynonyms = undefined
            setSearchTerms([...searchTerms]);
            setActiveIndex(-1);
            setActiveTerm(null);


        }else{
            setActiveIndex(index)
            setActiveTerm(searchTerms[index]);
        }


    }

    async function getOntoSuggestions(){

        if(userInfo != undefined && userInfo != null){            
            if(fullTextService.levenshteinDistance(searchForTerm, searchedTerm) > 2){

                let userId = userInfo && userInfo.current_user.gq_user_id;
                let searchParam = `&json_query=${encodeURIComponent(searchForTerm)}&rows=25&ontologies=${getOntologyString()}&user_id=${userId}`;
                console.log("Searching "+ searchForTerm) 
                const searchRes = await fullTextService.getFullTextSearchTerm(
                    history,
                    searchParam
                );

                //const searchRes = Test.test2;
                if(searchRes.response_content){
                    if(searchRes.response_content.results){
                        if (searchRes.response_content.results.length > 0) {
                            if(searchRes.response_content.results){
                                setSearchedTerm(searchForTerm)
                                setSearchTerms(searchRes.response_content.results);
                                
                            }
                        }
                    }	
                }
            }
        }
    }

    async function saveSearchTerm(){
    
        if(activeIndex !=-1){
    
            let userId = userInfo.current_user.gq_user_id;
            let wordRay = searchTerms[activeIndex].editedSynonyms;

            if(wordRay === undefined || wordRay === null){
                toast.error("Please make edits to save this term")
                return
            }
    
                let synonymString = "";
                if(wordRay.length > 0 && userId !== null && userId !== undefined){
    
                    wordRay = wordRay.filter((word) => word != "");
    
                    for(let i=0; i<wordRay.length; i++){
                        if(wordRay[i]!== ""){
                            synonymString+=wordRay[i];
                            if(i<wordRay.length-1){
                                synonymString+="\n";
                            }
                        }
                    }
    
                    if(synonymString!==""){
    
                        let postData={
                            user_id: userId,
                            term_id: searchTerms[activeIndex].id,
                            word_list: synonymString
                        }
    
                        if(searchTerms[activeIndex].id !== "Unsaved Term"){
                            postData.term_id = searchTerms[activeIndex].id;
                        }
    
                        //synonymEditor.current.innerHTML = ""
                        let response = await fullTextService.updateACSynonyms(postData, history);

                        if(response.response_content != undefined){
                            toast.success("Saved to User's Search Terms")
                            setSearchTerms([]);
                            setActiveTerm(null);                            
                        }

                    }
                }
    
            setSearchedTerm("");

        }else{
            toast.error("Cannot Save Empty List")
            return
        }
    }
      
    function cancelEdit(){
        
        if(activeIndex!== -1){
            if(searchTerms[activeIndex].editedSynonyms !== undefined){
                searchTerms[activeIndex].editedSynonyms = undefined
                setSearchTerms([...searchTerms]);
                setActiveTerm({...searchTerms[activeIndex]})
            }
        }
    }

    function setEditedSynonyms(wordRay){
        searchTerms[activeIndex].editedSynonyms = wordRay;
        setSearchTerms([...searchTerms])
    }

    return (
        <div className="fullWidthCenterAlign">
            <div className="CenterOntologies">
                <div style={{height: "71px", display: "flex", alignItems: "center", paddingLeft: "10px"}}>
                    <span className="subHeading">Browse and edit terms from ontologies</span>
                </div>
                <div className="ontologyTable">
                    <div style={{width: widthFunction()}}  className={`ontologyLeftFormat ${ toggle ? 'OntologyBoxBorder' : 'OntologyBoxBorderDark'}`} ref={leftRef}>
                        <div style={{margin: "5px", width: "100%"}}>
                            <input 
                                className="borderGrey"
                                style={{padding:"2px 5px", width: "100%", color: "#777777"}}
                                type="text"
                                onChange={(e)=>{setSearchForTerm(e.target.value)}}
                                value={searchForTerm}
                                placeholder="Enter term here"
                            />
                        </div>
                        <div className={`borderGrey ${toggle ? 'leftTableInnerContainer' : 'leftTableInnerContainerDark'}`}>
                            <div style={{width: "100%", height: "100%", padding: "0 5px", overflowX: "hidden", display: "flex", flexDirection: "column"}}>
                                {searchTerms.map((data, index) =>{
                                    return(
                                        <span onClick={()=>{selectOntology(index)}} key={index} className={index == activeIndex? "activeOntology": "notActiveOntology"}  style={{margin: "5px", textWrap: "pretty", cursor: "pointer"}}>
                                            <span className={data.taxonomy == "USER"? "autoqueryUser":"autoquery"}>{data.taxonomy}</span> {data.term}
                                        </span>
                                    )})
                                }
                            </div>
                        </div>
                    </div>

                    <div className={dragging? "dragBoxDragging" :"dragBox"} onDrag={(e)=>{resizeTable(e)}}
                        onDragStart={()=>setDragging(true)} 
                        onDragEnd={()=>setDragging(false)}
                    >
                    </div>

                    <div className={toggle ? "OntologyBoxBorder": "OntologyBoxBorderDark"} style={{width: "100%"}} >
                       
                    <div className={`borderBlue ${toggle? 'ontologyTextArea': 'ontologyTextAreaDark'}`}>
                            <SynonymEditor
                                term = {activeTerm}
                                setEditedSynonyms = {(wordRay)=>{setEditedSynonyms(wordRay)}}
                            >

                            </SynonymEditor>
                    </div>
                        <div className="ftOptionsButtons">
                                <div>
                                    <button className={"submitButtonClass"} onClick={()=>cancelEdit()}>Undo Changes</button>
                                    <button className={"ml-1 submitButtonClass"} onClick={()=>saveSearchTerm()}>Save</button>
                                </div>
                        </div>
                    </div>
                    <div style={{width: "700px", marginTop: '5px'}}>
                        {ontologyState !==null &&
                        <div>
                        {Object.entries(ontologyState).map(([key,value]) => {
                        return (
                            <div style={{paddingLeft: '10px'}} key={key+""}>
                              <table className="toppings-list-item">
                                <tr className="left-section">
                                 <td>
                                  <CheckBox
                                    color="primary"
                                    className={"float-left ml-2 mt-1"}
                                    id={key+'-id'}
                                    name={key+'-id'}
                                    checked={ontologyState[key][1]}
                                    onChange={()=> changeOntology(key)}
                                  />
                                  </td>
                                  <td style={{paddingLeft: '5px'}}>
                                    <label onClick={(e) => changeOntology(key)} className="makeStyles-checkBoxContent-88 bodyText ml-0 cursorPointer ontologyFix">{value[0]}</label>
                                  </td>
                                </tr>
                              </table>
                              {/* <span hidden>{modalUpdater}</span> */}
                              </div>
                          );
                        })}
                        </div>
                        }
                    </div>
                </div>
            </div>  
        </div>
    );
}

export default EditSearchTerms;
